var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 145,
    viewBox: "0 0 144 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1437 67.6823C49.1437 55.0587 59.3819 44.8204 72.0056 44.8204C84.6293 44.8204 94.8675 55.0587 94.8675 67.6823L94.8675 139.209H93.7874L93.7874 67.2007C93.7874 55.4417 84.2462 45.9005 72.4872 45.9005H71.524C59.765 45.9005 50.2238 55.4417 50.2238 67.2007L50.2238 139.209H49.1437L49.1437 67.6823Z",
    stroke: "#F9A003",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3742 15.1202C61.3742 9.25016 66.1244 4.5 71.9944 4.5C77.8644 4.5 82.6145 9.25016 82.6145 15.1202C82.6145 20.9902 77.8644 25.7403 71.9944 25.7403C66.1244 25.7403 61.3742 20.9902 61.3742 15.1202ZM71.9944 24.6602C77.2685 24.6602 81.5344 20.3943 81.5344 15.1202C81.5344 9.84606 77.2685 5.58011 71.9944 5.58011C66.7203 5.58011 62.4543 9.84606 62.4543 15.1202C62.4543 20.3943 66.7203 24.6602 71.9944 24.6602Z",
    stroke: "#F9A003",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58011 123.168L5.58011 139.175H4.5L4.5 118.688C4.5 108.797 12.5094 100.787 22.4002 100.787L50.2238 100.787L50.2238 139.175H49.1437L49.1437 106.368V101.868H44.6437L26.8803 101.868C15.1213 101.868 5.58011 111.409 5.58011 123.168Z",
    stroke: "#F9A003",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7017 71.0872C11.7017 65.2172 16.4518 60.467 22.3218 60.467C28.1918 60.467 32.942 65.2172 32.942 71.0872C32.942 76.9572 28.1918 81.7074 22.3218 81.7074C16.4518 81.7074 11.7017 76.9572 11.7017 71.0872ZM22.3218 80.6273C27.5959 80.6273 31.8619 76.3613 31.8619 71.0872C31.8619 65.8131 27.5959 61.5472 22.3218 61.5472C17.0477 61.5472 12.7818 65.8131 12.7818 71.0872C12.7818 76.3613 17.0477 80.6273 22.3218 80.6273Z",
    stroke: "#F9A003",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8563 82.2649L94.8563 139.713H93.7762L93.7762 76.6848L121.6 76.6848C131.491 76.6848 139.5 84.6942 139.5 94.5851L139.5 139.713H138.42L138.42 99.0651C138.42 87.3061 128.879 77.7649 117.12 77.7649L99.3563 77.7649H94.8563V82.2649Z",
    stroke: "#F9A003",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.058 46.9958C111.058 41.1258 115.808 36.3756 121.678 36.3756C127.548 36.3756 132.298 41.1258 132.298 46.9958C132.298 52.8658 127.548 57.6159 121.678 57.6159C115.808 57.6159 111.058 52.8658 111.058 46.9958ZM121.678 56.5358C126.952 56.5358 131.218 52.2699 131.218 46.9958C131.218 41.7217 126.952 37.4557 121.678 37.4557C116.404 37.4557 112.138 41.7217 112.138 46.9958C112.138 52.2699 116.404 56.5358 121.678 56.5358Z",
    stroke: "#F9A003",
    strokeWidth: 9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144.213,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.02d032d3a74e7818f060b1321acb4cb5.svg";
export { ForwardRef as ReactComponent };